
//------------------------------------------------------------------------------
// <auto-generated>
//     This code was generated from a template (Model.tst).
//
//     Manual changes to this file may cause unexpected behavior in your application.
//     Manual changes to this file will be overwritten if the code is regenerated.
// </auto-generated>
//------------------------------------------------------------------------------

import { OnHoldReason } from 'enums/OnHoldReason';
import { Model, ModelProperty } from 'models/Model';


export class OnHoldRequestModel extends Model<OnHoldRequestModel> {
	public static classProperties: ModelProperty[] = [
		
		{ name: 'companyId', type: 'string' },
		{ name: 'ledgerHeaderId', type: 'string' },
		{ name: 'onHoldReason', type: 'OnHoldReason' }
	];
	[key: string]: any;
	
	public companyId?: string;
	public ledgerHeaderId?: string;
	public onHoldReason?: OnHoldReason;
    
	constructor(){
		super();
		this.companyId = undefined;
		this.ledgerHeaderId = undefined;
		this.onHoldReason = undefined;
		
	}
	getProperties(){
		return OnHoldRequestModel.classProperties;
	}
}

